
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function SharedFooter() {
  const [nlEmail, setNlEmail] = useState('');
  const [nlSubmitted, setNlSubmitted] = useState(false);
  const [nlSubmitting, setNlSubmitting] = useState(false);

  const handleNewsletter = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!nlEmail) return;
    setNlSubmitting(true);
    try {
      const body = new URLSearchParams();
      body.append('email', nlEmail);
      await fetch('https://readdy.ai/api/form/d6acadea728k8ctu3880', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setNlSubmitted(true);
    } catch {
      setNlSubmitted(true);
    } finally {
      setNlSubmitting(false);
    }
  };

  const footerLinks = {
    Producto: [
      { label: 'Anamnesy Soft', href: '/#producto' },
      { label: 'Funcionalidades', href: '/#funcionalidades' },
      { label: 'Precios', href: '/precios' },
      { label: 'Seguridad', href: '/#faq' },
      { label: 'Módulo de Óptica', href: '/#funcionalidades' },
    ],
    Soluciones: [
      { label: 'Oftalmología', href: '/#producto' },
      { label: 'Optometría', href: '/#producto' },
      { label: 'Centros Ópticos', href: '/#producto' },
      { label: 'Clínicas Especializadas', href: '/#producto' },
    ],
    Recursos: [
      { label: 'Blog', href: '#' },
      { label: 'Casos de Éxito', href: '/#testimonios' },
      { label: 'Centro de Ayuda', href: '/#faq' },
      { label: 'Documentación API', href: '#' },
      { label: 'Webinars', href: '#' },
    ],
    Empresa: [
      { label: 'Sobre Nosotros', href: '/sobre-nosotros' },
      { label: 'Carreras', href: '#' },
      { label: 'Prensa', href: '#' },
      { label: 'Partners', href: '#' },
      { label: 'Contacto', href: '/#contacto' },
    ],
  };

  return (
    <footer className="bg-stone-100">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-10 mb-14">
          <div className="lg:col-span-2 space-y-5">
            <Link to="/" className="flex items-center space-x-2 cursor-pointer">
              <div className="w-9 h-9 bg-emerald-500 rounded-lg flex items-center justify-center">
                <i className="ri-eye-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-base font-bold text-gray-900 leading-none">La Millefera Tech</p>
                <span className="text-[10px] font-medium text-emerald-600 tracking-widest uppercase">LLC</span>
              </div>
            </Link>
            <p className="text-sm text-gray-500 leading-relaxed">
              Desarrollamos soluciones SaaS especializadas para la salud visual. Anamnesy Soft es nuestra plataforma líder en control oftalmológico.
            </p>

            {nlSubmitted ? (
              <div className="flex items-center space-x-2 text-emerald-600">
                <i className="ri-check-line text-base"></i>
                <span className="text-sm font-medium">¡Suscrito correctamente!</span>
              </div>
            ) : (
              <form id="newsletter-footer-form" data-readdy-form onSubmit={handleNewsletter} className="flex items-center space-x-2">
                <input
                  type="email"
                  name="email"
                  value={nlEmail}
                  onChange={(e) => setNlEmail(e.target.value)}
                  required
                  placeholder="tu@email.com"
                  className="flex-1 px-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:border-emerald-500 transition-colors bg-white"
                />
                <button
                  type="submit"
                  disabled={nlSubmitting}
                  className="px-5 py-2.5 bg-emerald-500 text-white text-sm font-semibold rounded-lg hover:bg-emerald-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-50"
                >
                  {nlSubmitting ? '...' : 'Suscribir'}
                </button>
              </form>
            )}

            <div className="flex items-center space-x-3 pt-2">
              {['ri-linkedin-fill', 'ri-twitter-x-fill', 'ri-instagram-fill', 'ri-youtube-fill'].map((icon, i) => (
                <a key={i} href="#" rel="nofollow" className="w-9 h-9 bg-gray-200 rounded-lg flex items-center justify-center hover:bg-emerald-500 hover:text-white transition-colors cursor-pointer text-gray-600">
                  <i className={`${icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="text-xs font-bold text-gray-900 uppercase tracking-wider mb-4">
                <a href="#" className="cursor-pointer">{category}</a>
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.href} className="text-sm text-gray-500 hover:text-emerald-600 transition-colors cursor-pointer">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-xs text-gray-400">
              © 2025 La Millefera Tech LLC. Todos los derechos reservados.
            </p>
            <div className="flex items-center space-x-5">
              <a href="#" className="text-xs text-gray-400 hover:text-emerald-600 transition-colors cursor-pointer">Política de Privacidad</a>
              <a href="#" className="text-xs text-gray-400 hover:text-emerald-600 transition-colors cursor-pointer">Términos de Servicio</a>
              <a href="#" className="text-xs text-gray-400 hover:text-emerald-600 transition-colors cursor-pointer">Seguridad</a>
              
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
